import { Component, Input } from '@angular/core';
import { IChatUser, IMentionableUsers } from '../../models/chat';
import { UserLogoGenerateComponent } from '../user-logo-generate/user-logo-generate.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'ph-user-tooltip',
    templateUrl: './ph-user-tooltip.component.html',
    styleUrls: ['./ph-user-tooltip.component.scss'],
    imports: [UserLogoGenerateComponent, PhIconComponent],
    standalone: true
})
export class PhUserTooltipComponent {

    @Input() user: IChatUser | IMentionableUsers | null;
}
